import React, { Component, Fragment } from 'react';
import { credentials } from '@shootsta/client-auth';
import { getStringValueFromGenericInput } from '@shootsta/get-value-from-generic-input';
import cx from 'classnames';
import { Image, Dropdown, Icon, Button } from '../../../../../ui-kit';

import ContentLoader from '../../../../ContentLoader';
import { getRoles, getSelectedRole } from '../../../utils';
import '../styles/_collaborators-list.scss';
















class CollaboratorsList extends Component {
  getEmptyText = () => {
    const { listItems, type } = this.props;

    if (!listItems) {
      return `Search for the ${type} that you want to add as collaborators`;
    }

    return `No ${type} found`;
  };

  handleButtonClick = (item) => () => {
    const { onAddMember } = this.props;

    if (!onAddMember) {return;}

    onAddMember(item);
  };

  changeAccessPermission = (item) => (result) => {
    const { onUpdateMember, roles = [] } = this.props;

    if (!onUpdateMember) {return;}

    const selectedRole = roles.
    find(({ description }) => description === getStringValueFromGenericInput(result));

    const updatedItem = { ...item, role: selectedRole };

    onUpdateMember(item.draftMemberId, updatedItem);
  };

  renderListItem({
    item,
    onRemoveMember,
    membersIds = [],
    currentUserId





  }) {
    const { type, roles = [] } = this.props;

    const isMembersTab = type === 'members';

    const { draftMemberId, userId, teamId, imageUrl, firstName = '', lastName = '', name, email = '', role, membersCount } = item;

    const displayName = name || `${firstName} ${lastName}`;

    return (
      <Fragment key={draftMemberId}>
        <div className="collaborators-list__item">
          <Image
            imageUrl={imageUrl}
            placeholderText={displayName}
            width="75px"
            height="75px"
            rounded />

          <div className="collaborators-list__item__info">
            <p className="collaborators-list__item__info__primary">{`${displayName}${userId === currentUserId ? ' (you)' : ''}`}</p>
            <p className="collaborators-list__item__info__secondary">{userId ? email : `MEMBERS: ${membersCount || 0}`}</p>
          </div>
          <div className={cx('collaborators-list__item__right-container', { 'collaborators-list__item__right-container__add': !isMembersTab })}>
            {isMembersTab ?

            <Dropdown
              key={`${draftMemberId}-${role?.name}`}
              className="collaborators-list__item__right-container__role-dropdown"
              type="BASIC"
              onChange={this.changeAccessPermission(item)}
              defaultValue={getSelectedRole(role, roles)}
              options={getRoles(roles)} /> :



            <Button
              className="collaborators-list__item__right-container__button"
              onClick={this.handleButtonClick(item)}
              type="PRIMARY"
              disabled={membersIds.includes(userId || teamId)}>

                  {membersIds.includes(userId || teamId) ? 'Added' : `Add ${type === 'users' ? 'User' : 'Team'}`}
                </Button>}

            {isMembersTab ?

            <Icon
              name="close"
              size={15}
              onClick={onRemoveMember(draftMemberId)}
              className={cx('collaborators-list__item__right-container__remove-icon')}
              color="nevada"
              hoverColor="black" /> :


            null}
          </div>
        </div>
        <hr className="collaborators-list__horizontal-line" />
      </Fragment>);

  }

  renderLoadingItem = () =>
  <div className="collaborators-list__loading">
      <ContentLoader height={75} width={600} viewBox={null}>
        <rect x="0" y="0" rx="0" ry="0" width={75} height={75} />
        <rect x="90" y="32" rx="0" ry="0" width={600} height={15} />
      </ContentLoader>
    </div>;


  render() {
    const { listItems, onRemoveMember, type, membersIds, loading } = this.props;
    const { user: { userId: currentUserId = '' } = {} } = credentials.get();

    if (loading) {
      return (
        <div className="collaborators-list">
          {this.renderLoadingItem()}
          <hr className="collaborators-list__horizontal-line" />
          {this.renderLoadingItem()}
          <hr className="collaborators-list__horizontal-line" />
          {this.renderLoadingItem()}
        </div>);

    }

    return (
      <div className="collaborators-list">
        {!listItems || !listItems.length ?

        <div className="collaborators-list__empty">
              <p className="collaborators-list__empty__text">
                {
            this.getEmptyText()}

              </p>
            </div> :

        listItems.map((item) => this.renderListItem({
          item,
          onRemoveMember,
          type,
          membersIds,
          currentUserId
        }))}
      </div>);

  }
}

export default CollaboratorsList;